// src/shared/hubspotProducts.js
//
// The product list the agreement is tagged with in HubSpot — written to the
// deal's "Software" checkbox so deals can be filtered by product.
//
// These are DELIBERATELY not the template names. A template is named for the
// document it produces ("CQMsolution Add Measures", "Dynamic FHIR API Hosted
// Services"); HubSpot is filtered by product line, and several templates belong
// to one product. So the rep picks the product(s) explicitly in the builder
// rather than the app inferring it from which templates are selected.
//
// Each entry must match an option on the HubSpot property exactly — the API
// rejects the whole write if any value isn't a real option. Confirm the option
// list with:  node tools/hubspot-inspect.js software
//
// CommonJS + dependency-free like the rest of src/shared — the Node server
// require()s it and the CRA client imports it.

const SOFTWARE_OPTIONS = [
  'Dynamic FHIR',
  'CQMsolution',
  'ConnectEHR',
  'Registry',
  'TIE',
  'Consulting',
];

// Keep only recognised options, in the canonical order, without duplicates.
// Anything a stale draft or an old client sends that is no longer an option is
// dropped here rather than being rejected by HubSpot at send time.
function normalizeProducts(values) {
  const wanted = new Set((values || []).map(v => String(v || '').trim().toLowerCase()));
  return SOFTWARE_OPTIONS.filter(o => wanted.has(o.toLowerCase()));
}

module.exports = { SOFTWARE_OPTIONS, normalizeProducts };
